/* =========================================
   GLOBAL SAFETY GUARDS (NO REDECLARATION)
========================================= */
window.__DEVX_PUBSUB__ = window.__DEVX_PUBSUB__ || {};
window.__DEVX_PUBSUB__.subscribers =
  window.__DEVX_PUBSUB__.subscribers || {};

let subscribers = window.__DEVX_PUBSUB__.subscribers;

/* =========================================
   PUB / SUB (UNCHANGED LOGIC)
========================================= */
function subscribe(eventName, callback) {
  if (!subscribers[eventName]) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter(
      (cb) => cb !== callback
    );
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => callback(data));
  }
}

/* =========================================
   EYE PATCH CAPPING CONFIG
========================================= */
const cappedVariantIds = [
  41892488839333,
  40325864751269
];
let isProcessing = false;

/* =========================================
   BIND CLICK LOGIC
========================================= */
function bindEyePatchCapping() {
  const capEl = document.getElementById("eye-patch-capping-on");

  const CAP_ENABLED =
    capEl && /^(?:1|true|yes|on)$/i.test(String(capEl.value).trim());

  if (!CAP_ENABLED) return;

  document.querySelectorAll(".devx_eye_patch").forEach((element) => {
    if (element.dataset.cappingBound === "true") return;

    element.dataset.cappingBound = "true";

    element.addEventListener("click", function (e) {
      e.preventDefault();

      if (isProcessing) return;

      const variantInput = this.querySelector(".dev_home_getvariantid");
      const button = this.querySelector("button");
      const variantId = Number(variantInput?.value);

      if (!variantId || !button) return;

      isProcessing = true;
      button.disabled = true;

      /* ==============================
         CHECK IF VARIANT IS CAPPED
      ============================== */
      if (cappedVariantIds.includes(variantId)) {
        fetch("/cart.js")
          .then((res) => res.json())
          .then((cart) => {
           const existingItem = cart.items.find(
             (item) => item.variant_id === variantId
            );

            const alreadyExists = existingItem && existingItem.quantity >= 1;

            if (alreadyExists) {
              document
                .querySelector(".popup-overlay")
                ?.style.setProperty("display", "block");

              resetButton(button);
            } else {
              addProductToCart(variantId, 1, button);
            }
          })
          .catch(() => {
            resetButton(button);
          });
      } else {
        addProductToCart(variantId, 1, button);
      }
    });
  });
}

/* =========================================
   SAFE MUTATION OBSERVER (NO DUPLICATE)
========================================= */
if (!window.__DEVX_PUBSUB__) {
  window.__DEVX_PUBSUB__ = {};
}

if (!window.__DEVX_PUBSUB__.observerInitialized) {
  window.__DEVX_PUBSUB__.observerInitialized = true;

  const observer = new MutationObserver(() => {
    bindEyePatchCapping();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

/* =========================================
   INITIAL LOAD
========================================= */
document.addEventListener("DOMContentLoaded", bindEyePatchCapping);

/* =========================================
   CART FUNCTIONS
========================================= */
function addProductToCart(variantId, quantity = 1, button) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: `id=${variantId}&quantity=${quantity}`,
  })
    .then((res) => res.json())
    .then(() => updateCartDrawer())
    .catch((err) => {
      console.error("Cart add error:", err);
    })
    .finally(() => {
      resetButton(button);
    });
}

function updateCartDrawer() {
  if (!window.section2) return;

  fetch(`/?section_id=${window.section2}`)
    .then((res) => res.text())
    .then((html) => {
      const section = document.getElementById(
        `shopify-section-${window.section2}`
      );

      if (section) {
        section.innerHTML = html;
      }

      document
        .querySelector("cart-drawer#cart-drawer-unique")
        ?.classList.add("active");

      updateCartIconBubble();
    })
    .catch((err) => {
      console.error("Cart drawer update error:", err);
    });
}

function updateCartIconBubble() {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const icon = document.querySelector(".dev_desktop_cart_icon");
      if (!icon) return;

      icon.querySelector(".cart-count-bubble")?.remove();

      const bubble = document.createElement("div");
      bubble.className = "cart-count-bubble";
      bubble.innerHTML = `
        <span aria-hidden="true">${cart.item_count}</span>
        <span class="visually-hidden">${cart.item_count} items</span>
      `;

      icon.appendChild(bubble);
    })
    .catch((err) => {
      console.error("Cart bubble error:", err);
    });
}

/* =========================================
   RESET BUTTON HELPER
========================================= */
function resetButton(button) {
  isProcessing = false;
  if (button) button.disabled = false;
}

console.log("pubsub.js loaded safely ✅");